import EntityStore from '#/unified-rfqs/store/entity';
import { Drfq } from '../entities/drfq/domain';

export class DrfqDraftsStore extends EntityStore<Drfq> {
  constructor() {
    const sortComparer = (drfqA: Drfq, drfqB: Drfq) =>
      drfqB.last_updated_at.getTime() - drfqA.last_updated_at.getTime();

    super({ sortComparer });
  }
}
